import { useState } from 'react'
import { getPetsWithFilter, getPetById } from '../services/pet'

export const useGetPet = () => {
  const [pets, setPets] = useState()
  const [pet, setPet] = useState()
  const [total, setTotal] = useState()
  const [loading, setLoading] = useState(false)

  const reset = () => {
    setPets([])
    setTotal(0)
  }

  const getPetsFiltered = async (data) => {
    const { name, breedType, breedId, gender } = data
    setLoading(true)
    try {
      if (!name && !breedType && !breedId && !gender) {
        setPets([])
        setTotal(0)
        return
      }
      const pets = await getPetsWithFilter(data)
      setPets(pets.list)
      setTotal(pets.total)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const getPet = async (id) => {
    setLoading(true)
    try {
      const pet = await getPetById(id)
      setPet(pet)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return {
    pets,
    pet,
    total,
    loading,
    getPet,
    getPetsFiltered,
    setPet,
    setPets,
    reset
  }
}
